$(document).ready(function () {
    const $isDelticoreFailurePayment = $('input[name="isDelticoreFailurePayment"]');
    const isDelticoreFailurePayment =
        $isDelticoreFailurePayment.val() === 'true';

    if (isDelticoreFailurePayment) {
        $('.payment-cancelled-notice').removeClass('hide');
    }
});
